<li [class.has-children]="node.children && node.children.length">
  <div class="node">
    <ng-container *ngIf="node.children && node.children.length; else placeholder">
      <button type="button" class="expander" (click)="toggleExpand($event)">{{ isExpanded() ? '▼' : '▶' }}</button>
    </ng-container>
    <ng-template #placeholder>
      <span class="expander-placeholder"></span>
    </ng-template>
    <input type="checkbox" [checked]="!((states?.get(node) ?? 0) === 0)" [indeterminate]="(states?.get(node) ?? 0) === 2" (change)="onToggle(node)" />
    <span [class.selected]="node.selected" (click)="selectNode(node)">{{node.label}}</span>
  </div>
  <ul *ngIf="node.children && node.children.length && isExpanded()" class="tree-children">
    <ng-container *ngFor="let c of node.children">
      <app-orderline-tree-node [node]="c" [states]="states" (nodeSelected)="selectNode($event)" (nodeToggle)="nodeToggle.emit($event)" ></app-orderline-tree-node>
    </ng-container>
  </ul>
</li>
